import { init } from './MallCPAPlus';
init();
